import { combineReducers } from 'redux';
import {
  LIBRARY_SALES_TYPE_SET_LIST_SALES,
  LIBRARY_SALES_TYPE_SET_OUTLETS,
  LIBRARY_SALES_TYPE_SET_SALES_DETAIL,
  LIBRARY_SALES_TYPE_CLOSE_RIGHT_COLUMN,
  LIBRARY_SALES_TYPE_SET_TOTAL_PAGE,
  LIBRARY_SALES_TYPE_SET_CURRENT_PAGE,
  LIBRARY_SALES_TYPE_OPEN_RIGHT_COLUMN,
  LIBRARY_SALES_TYPE_SET_GRATUITY,
  LIBRARY_SALES_TYPE_SET_MUST_SCROLL_TOP,
  LIBRARY_SALES_TYPE_SHOW_DELETE_MODAL,
  LIBRARY_SALES_TYPE_SET_DELETED_SALES,
  LIBRARY_SALES_TYPE_HIDE_DELETE_MODAL,
  LIBRARY_SALES_TYPE_SET_ACTIVATED_SALES,
  LIBRARY_SALES_TYPE_SHOW_ACTIVATED_MODAL,
  LIBRARY_SALES_TYPE_HIDE_ACTIVATED_MODAL,
  LIBRARY_SALES_TYPE_SET_STATUS_GRATUITY,
  LIBRARY_SALES_TYPE_IS_SUBMITTING_FORM,
  LIBRARY_SALES_TYPE_SHOW_SAVE_TO_ALL_OUTLETS_MODAL,
  LIBRARY_SALES_TYPE_SET_FAILED_OUTLETS,
  LIBRARY_SALES_TYPE_HIDE_SAVE_TO_ALL_OUTLETS_MODAL,
  LIBRARY_SALES_TYPE_SHOW_NO_GRATUITY_MODAL,
  LIBRARY_SALES_TYPE_HIDE_NO_GRATUITY_MODAL,
  LIBRARY_SALES_TYPE_SHOW_CHECK_DELETABLE_MODAL,
  LIBRARY_SALES_TYPE_SET_SALES_TYPE_RESERVED,
} from 'actions/library/salesType/constants';

import createReducer from 'utils/createReducer';

const activatedSalesType = createReducer(null, {
  [LIBRARY_SALES_TYPE_SET_ACTIVATED_SALES]: (draft, { payload }) =>
    payload.activatedSalesType,
});

const checkDeletableModalType = createReducer('', {
  [LIBRARY_SALES_TYPE_SHOW_CHECK_DELETABLE_MODAL]: (draft, { payload }) =>
    payload.type,
});

const currentPage = createReducer(null, {
  [LIBRARY_SALES_TYPE_SET_CURRENT_PAGE]: (draft, { payload }) =>
    payload.currentPage,
});

const deletedSalesType = createReducer(null, {
  [LIBRARY_SALES_TYPE_SET_DELETED_SALES]: (draft, { payload }) =>
    payload.deletedSalesType,
});

const enableGratuity = createReducer(null, {
  [LIBRARY_SALES_TYPE_SET_STATUS_GRATUITY]: (draft, { payload }) =>
    payload.enableGratuity,
});

const failedOutlets = createReducer(null, {
  [LIBRARY_SALES_TYPE_SET_FAILED_OUTLETS]: (draft, { payload }) =>
    payload.failedOutlets,
});

const gratuity = createReducer([], {
  [LIBRARY_SALES_TYPE_SET_GRATUITY]: (draft, { payload }) => payload.gratuity,
});

const isSubmittingForm = createReducer(false, {
  [LIBRARY_SALES_TYPE_IS_SUBMITTING_FORM]: (draft, { payload }) =>
    payload.isSubmittingForm,
});

const mustScrollTop = createReducer(false, {
  [LIBRARY_SALES_TYPE_SET_MUST_SCROLL_TOP]: (draft, { payload }) =>
    payload.mustScrollTop,
});

const NoGratuityModal = createReducer(
  {
    show: false,
    action: null,
  },
  {
    [LIBRARY_SALES_TYPE_SHOW_NO_GRATUITY_MODAL]: (draft, { payload }) => ({
      show: true,
      action: payload.action,
    }),

    [LIBRARY_SALES_TYPE_HIDE_NO_GRATUITY_MODAL]: () => ({
      show: false,
      action: null,
    }),
  }
);

const openRightColumn = createReducer(false, {
  [LIBRARY_SALES_TYPE_CLOSE_RIGHT_COLUMN]: () => false,
  [LIBRARY_SALES_TYPE_OPEN_RIGHT_COLUMN]: () => true,
});

const outlets = createReducer([], {
  [LIBRARY_SALES_TYPE_SET_OUTLETS]: (draft, { payload }) => payload.outlets,
});

const salesType = createReducer([], {
  [LIBRARY_SALES_TYPE_SET_LIST_SALES]: (draft, { payload }) =>
    payload.salesType,
});

const salesTypeDetail = createReducer(null, {
  [LIBRARY_SALES_TYPE_SET_SALES_DETAIL]: (draft, { payload }) =>
    payload.salesTypeDetail,
});

const showActivatedModal = createReducer(false, {
  [LIBRARY_SALES_TYPE_SHOW_ACTIVATED_MODAL]: () => true,
  [LIBRARY_SALES_TYPE_HIDE_ACTIVATED_MODAL]: () => false,
});

const showCheckDeletableModal = createReducer(false, {
  [LIBRARY_SALES_TYPE_SHOW_CHECK_DELETABLE_MODAL]: (draft, { payload }) =>
    payload.showCheckDeletableModal,
});

const showDeleteModal = createReducer(false, {
  [LIBRARY_SALES_TYPE_SHOW_DELETE_MODAL]: () => true,
  [LIBRARY_SALES_TYPE_HIDE_DELETE_MODAL]: () => false,
});

const showSaveToAllOutletsModal = createReducer(false, {
  [LIBRARY_SALES_TYPE_SHOW_SAVE_TO_ALL_OUTLETS_MODAL]: () => true,
  [LIBRARY_SALES_TYPE_HIDE_SAVE_TO_ALL_OUTLETS_MODAL]: () => false,
});

const totalPage = createReducer(null, {
  [LIBRARY_SALES_TYPE_SET_TOTAL_PAGE]: (draft, { payload }) =>
    payload.totalPage,
});

const salesTypeReserved = createReducer(null, {
  [LIBRARY_SALES_TYPE_SET_SALES_TYPE_RESERVED]: (draft, { payload }) =>
    payload.salesTypeReserved,
});

export default combineReducers({
  activatedSalesType,
  checkDeletableModalType,
  currentPage,
  deletedSalesType,
  enableGratuity,
  failedOutlets,
  gratuity,
  isSubmittingForm,
  mustScrollTop,
  NoGratuityModal,
  openRightColumn,
  outlets,
  salesType,
  salesTypeDetail,
  showActivatedModal,
  showCheckDeletableModal,
  showDeleteModal,
  showSaveToAllOutletsModal,
  totalPage,
  salesTypeReserved,
});
